import React from "react";
import type { Project } from "../../../../../../../../api/useProjects";
import BlankStateV2 from "@ui/BlankStateV2";
import { useNavigate } from "react-router";
import t from "../../../../../../../../i18n";
import { toPath } from "../../../../../../../../router/helpers/path";
import { DataProcessing } from "@ui/Illustration/react";

const BlankStateAnyIndicatorPerfomance = ({ project }: { project: Project }) => {
  const navigate = useNavigate();

  return (
    <BlankStateV2
      picto={<DataProcessing />}
      title={t("project.event.diagnosed_tab.blank_state.any_pi.title")}
      subtitle={t("project.event.diagnosed_tab.blank_state.any_pi.subtitle")}
      onClick={() =>
        navigate(
          toPath("/projects/:projectId/settings", {
            projectId: project.id,
          }),
        )
      }
      buttonLabel={t("project.event.diagnosed_tab.blank_state.any_pi.action")}
    />
  );
};
export default BlankStateAnyIndicatorPerfomance;
